










import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  NavigationPane,
  IImageSpecifiableButtonState,
} from "../../../../base/components/panes";
import { ExternalMenuButton } from "../../../../base/components/system";
import { ExternalMenuMixin } from "../../../../base/components/system/mixins";
import { IExternalMenuItemConfiguration } from "../../../../base/domain/configuration";
import { EditableFormatSummary } from "../../../domain/editableFormat";

@Component({
  components: {
    NavigationPane,
    ExternalMenuButton,
  },
})
export default class ExternalMenu extends Mixins(ExternalMenuMixin) {
  @Prop({ default: null })
  format: EditableFormatSummary;

  @Prop({ default: () => [] as IExternalMenuItemConfiguration[] })
  items: IExternalMenuItemConfiguration[];

  get buttons(): IImageSpecifiableButtonState[] {
    // ExternalMenuParameterSourceはがちがちにパラメータを持ってる.
    // フォーマット編集用に改めて拡張するのも微妙なので文書IDで代用.
    // (フォーマット編集で文書IDは使わないし、文書IDを使えば選択中判定とかもちゃんと動くようなので.)
    const source = this.createParameterSource();
    source.documentId = this.format ? this.format.id : null;
    return this.items.map(i => this.toButtonState(i, false, source));
  }
}
